module.exports = __webpack_public_path__ + "static/media/illustration_contact-icons.06fc9eb2.svg";